module.exports = __webpack_public_path__ + "static/media/phoneIcon.d3282a36.svg";